/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

import './ProfileAvatar.css';

import colorThemeSelectors from 'redux/reduxStore/colorTheme';
import Circle from 'components/images/Circle';
import AppUtils from '../../../lib/AppUtils';

const ProfileAvatar = ({ profile, size, fontSize, strokeWidth, text, style, isActive, colorTheme }) => {
  return profile.avatar_photo
  ? (
    <div
      className="cmp-avatar"
      style={_.assign({}, { width: `${size}px`, height: `${size}px` }, style)}
    >
      <img
        src={profile.avatar_photo}
        style={_.assign({}, { width: `${size}px`, height: `${size}px` })}
        alt="avatar"
      />
    </div>
  ) : (
    <div className="cmp-avatar nophoto" style={_.assign({}, { width: `${size}px`, height: `${size}px` }, style)}>
      <Circle style={{ fill: AppUtils.cssColor(colorTheme.base_color) }} size={size} strokeWidth={strokeWidth} strokeColor="white" />

      <div className="initials" style={{ fontSize: `${fontSize}px`, lineHeight: `${size}px` }}>
        {profile.avatar_initials}
      </div>
    </div>
  );
}
ProfileAvatar.propTypes = {
  profile: PropTypes.object.isRequired,
  size: PropTypes.number,
  fontSize: PropTypes.number,
  text: PropTypes.string,
  style: PropTypes.object,
  getColorTheme: PropTypes.func,
};
ProfileAvatar.defaultProps = {
  size: 40,
  fontSize: 14,
  strokeWidth: 1,
};

function mapStateToProps(state, props) {
  const colorTheme = colorThemeSelectors.get(state, props.profile.color_theme_id) || {};
  return {
    colorTheme,
  };
}
export default connect(mapStateToProps)(ProfileAvatar);